import { createApp } from 'vue';

import CorporateBannerBlock from '../CorporateBannerBlock/CorporateBannerBlock.vue';

function mountCorporateBannerBlocks() {
	const blocks = document.querySelectorAll('[data-feature="corporate-banner-block"]');

	blocks.forEach((block) => {
		const app = createApp({
			name: 'CorporateBannerBlockApp',
		});

		app.component('corporate-banner-block', CorporateBannerBlock);
		app.mount(block);
	})
}

mountCorporateBannerBlocks();